/**
 * TikTok Login Kit configuration (SGL-170).
 *
 * Same shape as bingEnv.ts: no client secret in the bundle (the backend exchanges
 * the code — POST /{customer_id}/tiktok/exchange-token), and a redirect URI
 * computed from the origin rather than configured. The Connect card is hidden
 * unless a client key is set, so the feature ships dormant.
 */

/** Space-free, comma-separated: TikTok's authorize endpoint wants commas. */
export const TIKTOK_SCOPES = "user.info.basic,video.publish,video.upload";

export function getTikTokClientKey(): string | undefined {
  return process.env.REACT_APP_TIKTOK_CLIENT_KEY?.trim() || undefined;
}

/** Sent in the authorize URL and the exchange body; must be registered on the TikTok app. */
export function getTikTokRedirectUri(): string {
  return `${window.location.origin}/connect/tiktok/callback`;
}

export function isTikTokConfigured(): boolean {
  return Boolean(getTikTokClientKey());
}
